<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      var startScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (startScroll <= 0) return;

      var duration = 1000;
      var startTime = null;

      function easeOutCubic(progress) {
        return 1 - Math.pow(1 - progress, 3);
      }

      function scrollToTop(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var nextScroll = startScroll * (1 - easeOutCubic(progress));

        window.scrollTo(0, nextScroll);

        if (progress < 1) {
          window.requestAnimationFrame(scrollToTop);
        } else {
          window.scrollTo(0, 0);
        }
      }

      window.requestAnimationFrame(scrollToTop);
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
  background: var(--color-accent);
  border: none;
  border-radius: var(--radius);
  transition: all 0.2s ease;
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  justify-content: center;
}
#GoTop:hover {
  background: var(--color-accent-hover);
  box-shadow: var(--shadow-lg);
}
#GoTop > span {
  color: var(--color-on-accent);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue